import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { NotificacaoService } from './core/services/notificacao.service';

@Component({
  selector: 'app-root',
  template: `
    <ng-container *ngIf="(auth.usuario$ | async) as usuario; else semLayout">
      <app-header></app-header>
      <div class="app-container">
        <app-sidebar></app-sidebar>
        <main class="app-content">
          <router-outlet></router-outlet>
        </main>
      </div>
    </ng-container>
    <ng-template #semLayout>
      <router-outlet></router-outlet>
    </ng-template>
  `,
  styles: [`
    .app-container { display: flex; height: calc(100vh - 64px); }
    .app-content   { flex: 1; overflow-y: auto; padding: 24px; background: #f5f5f5; }
  `]
})
export class AppComponent implements OnInit {
  constructor(public auth: AuthService, private notificacao: NotificacaoService) {}

  ngOnInit(): void {
    if (this.auth.estaAutenticado()) {
      this.notificacao.iniciar();
    }
    this.auth.usuario$.subscribe(u => {
      if (u) this.notificacao.iniciar();
      else   this.notificacao.parar();
    });
  }
}